// Complete slug mapping for ALL detail pages across TR/EN/AZ
// Every slug must map to all 3 language equivalents
import { ROUTE_MAP } from './routes';

// ============================================
// APPLICATIONS - 16 items (TR/EN/AZ matched)
// ============================================
export const applicationSlugs = {
  // TR -> EN, AZ
  'basinc-tahliye-vanalari': { tr: 'basinc-tahliye-vanalari', en: 'pressure-relief-valves', az: 'tezyiq-bosaltma-vanalari' },
  'buyuk-vanalar': { tr: 'buyuk-vanalar', en: 'large-valves', az: 'boyuk-vanalar' },
  'dar-alanlar': { tr: 'dar-alanlar', en: 'confined-spaces', az: 'dar-saheler' },
  'hammadde-saflastirma': { tr: 'hammadde-saflastirma', en: 'feedstock-purification', az: 'xammal-saflashdirma' },
  'insan-performansi': { tr: 'insan-performansi', en: 'human-performance', az: 'insan-performansi' },
  'isi-esanjoru': { tr: 'isi-esanjoru', en: 'heat-exchangers', az: 'istilik-deyisdiricileri' },
  'kimyasal-bosaltma': { tr: 'kimyasal-bosaltma', en: 'chemical-offload', az: 'kimyevi-bosaltma' },
  'korozyon-izleme': { tr: 'korozyon-izleme', en: 'corrosion-monitoring', az: 'korroziya-izleme' },
  'pigleme': { tr: 'pigleme', en: 'pigging', az: 'piqlenme' },
  'pompa-baslatma': { tr: 'pompa-baslatma', en: 'pump-start', az: 'nasos-baslatma' },
  'radyasyon-korunma': { tr: 'radyasyon-korunma', en: 'radiation-protection', az: 'radiasiya-qoruma' },
  'ulasimi-zor-vanalar': { tr: 'ulasimi-zor-vanalar', en: 'hard-to-reach', az: 'cetin-elcatan-vanalar' },
  'ldpe-proses-guvenligi': { tr: 'ldpe-proses-guvenligi', en: 'ldpe-process-safety', az: 'ldpe-proses-tehlukesizliyi' },
  'fpso-operasyon-guvenligi': { tr: 'fpso-operasyon-guvenligi', en: 'fpso-operation-safety', az: 'fpso-emeliyyat-tehlukesizliyi' },
  'dijital-anahtar-yonetimi-pigleme': { tr: 'dijital-anahtar-yonetimi-pigleme', en: 'digital-key-management-pigging', az: 'reqemsal-acar-idareetmesi-pigleme' },
  'prv-gecisinde-asiri-basinc-koruma': { tr: 'prv-gecisinde-asiri-basinc-koruma', en: 'prv-switchover-overpressure-protection', az: 'prv-kecidinde-artiq-tezyiq-qorunmasi' },
  // EN -> TR, AZ
  'pressure-relief-valves': { tr: 'basinc-tahliye-vanalari', en: 'pressure-relief-valves', az: 'tezyiq-bosaltma-vanalari' },
  'large-valves': { tr: 'buyuk-vanalar', en: 'large-valves', az: 'boyuk-vanalar' },
  'confined-spaces': { tr: 'dar-alanlar', en: 'confined-spaces', az: 'dar-saheler' },
  'feedstock-purification': { tr: 'hammadde-saflastirma', en: 'feedstock-purification', az: 'xammal-saflashdirma' },
  'human-performance': { tr: 'insan-performansi', en: 'human-performance', az: 'insan-performansi' },
  'heat-exchangers': { tr: 'isi-esanjoru', en: 'heat-exchangers', az: 'istilik-deyisdiricileri' },
  'chemical-offload': { tr: 'kimyasal-bosaltma', en: 'chemical-offload', az: 'kimyevi-bosaltma' },
  'corrosion-monitoring': { tr: 'korozyon-izleme', en: 'corrosion-monitoring', az: 'korroziya-izleme' },
  'pigging': { tr: 'pigleme', en: 'pigging', az: 'piqlenme' },
  'pump-start': { tr: 'pompa-baslatma', en: 'pump-start', az: 'nasos-baslatma' },
  'radiation-protection': { tr: 'radyasyon-korunma', en: 'radiation-protection', az: 'radiasiya-qoruma' },
  'hard-to-reach': { tr: 'ulasimi-zor-vanalar', en: 'hard-to-reach', az: 'cetin-elcatan-vanalar' },
  'ldpe-process-safety': { tr: 'ldpe-proses-guvenligi', en: 'ldpe-process-safety', az: 'ldpe-proses-tehlukesizliyi' },
  'fpso-operation-safety': { tr: 'fpso-operasyon-guvenligi', en: 'fpso-operation-safety', az: 'fpso-emeliyyat-tehlukesizliyi' },
  'digital-key-management-pigging': { tr: 'dijital-anahtar-yonetimi-pigleme', en: 'digital-key-management-pigging', az: 'reqemsal-acar-idareetmesi-pigleme' },
  'prv-switchover-overpressure-protection': { tr: 'prv-gecisinde-asiri-basinc-koruma', en: 'prv-switchover-overpressure-protection', az: 'prv-kecidinde-artiq-tezyiq-qorunmasi' },
  // AZ -> TR, EN
  'tezyiq-bosaltma-vanalari': { tr: 'basinc-tahliye-vanalari', en: 'pressure-relief-valves', az: 'tezyiq-bosaltma-vanalari' },
  'boyuk-vanalar': { tr: 'buyuk-vanalar', en: 'large-valves', az: 'boyuk-vanalar' },
  'dar-saheler': { tr: 'dar-alanlar', en: 'confined-spaces', az: 'dar-saheler' },
  'xammal-saflashdirma': { tr: 'hammadde-saflastirma', en: 'feedstock-purification', az: 'xammal-saflashdirma' },
  'istilik-deyisdiricileri': { tr: 'isi-esanjoru', en: 'heat-exchangers', az: 'istilik-deyisdiricileri' },
  'kimyevi-bosaltma': { tr: 'kimyasal-bosaltma', en: 'chemical-offload', az: 'kimyevi-bosaltma' },
  'korroziya-izleme': { tr: 'korozyon-izleme', en: 'corrosion-monitoring', az: 'korroziya-izleme' },
  'piqlenme': { tr: 'pigleme', en: 'pigging', az: 'piqlenme' },
  'nasos-baslatma': { tr: 'pompa-baslatma', en: 'pump-start', az: 'nasos-baslatma' },
  'radiasiya-qoruma': { tr: 'radyasyon-korunma', en: 'radiation-protection', az: 'radiasiya-qoruma' },
  'cetin-elcatan-vanalar': { tr: 'ulasimi-zor-vanalar', en: 'hard-to-reach', az: 'cetin-elcatan-vanalar' },
  'ldpe-proses-tehlukesizliyi': { tr: 'ldpe-proses-guvenligi', en: 'ldpe-process-safety', az: 'ldpe-proses-tehlukesizliyi' },
  'fpso-emeliyyat-tehlukesizliyi': { tr: 'fpso-operasyon-guvenligi', en: 'fpso-operation-safety', az: 'fpso-emeliyyat-tehlukesizliyi' },
  'reqemsal-acar-idareetmesi-pigleme': { tr: 'dijital-anahtar-yonetimi-pigleme', en: 'digital-key-management-pigging', az: 'reqemsal-acar-idareetmesi-pigleme' },
  'prv-kecidinde-artiq-tezyiq-qorunmasi': { tr: 'prv-gecisinde-asiri-basinc-koruma', en: 'prv-switchover-overpressure-protection', az: 'prv-kecidinde-artiq-tezyiq-qorunmasi' },
};

// ============================================
// PRODUCTS - 15 items (TR/EN/AZ matched)
// ============================================
export const productSlugs = {
  // TR slugs (same in all languages for brand names)
  'smith-interlocks': { tr: 'smith-interlocks', en: 'smith-interlocks', az: 'smith-interlocks' },
  'netherlocks-interlocks': { tr: 'netherlocks-interlocks', en: 'netherlocks-interlocks', az: 'netherlocks-interlocks' },
  'flexidrive': { tr: 'flexidrive', en: 'flexidrive', az: 'flexidrive' },
  'easidrive': { tr: 'easidrive', en: 'easidrive', az: 'easidrive' },
  'power-wrench': { tr: 'power-wrench', en: 'power-wrench', az: 'power-wrench' },
  'vpi': { tr: 'vpi', en: 'vpi', az: 'vpi' },
  // TR specific slugs
  'anahtar-yonetimi': { tr: 'anahtar-yonetimi', en: 'anahtar-yonetimi', az: 'acar-idareetmesi' },
  'sira-kontrolu': { tr: 'sira-kontrolu', en: 'sira-kontrolu', az: 'ardicillik-nezareti' },
  'netherlocks-mrl-vana-kilitleri': { tr: 'netherlocks-mrl-vana-kilitleri', en: 'netherlocks-mrl-vana-kilitleri', az: 'netherlocks-mrl-vana-kilitleri' },
  'netherlocks-ndl-ceyrek-donus-kilitleri': { tr: 'netherlocks-ndl-ceyrek-donus-kilitleri', en: 'netherlocks-ndl-ceyrek-donus-kilitleri', az: 'netherlocks-ndl-ceyrek-donus-kilitleri' },
  'smith-gl-vana-kilitleri': { tr: 'smith-gl-vana-kilitleri', en: 'smith-gl-vana-kilitleri', az: 'smith-gl-vana-kilitleri' },
  'smith-ql-vana-kilitleri': { tr: 'smith-ql-vana-kilitleri', en: 'smith-ql-vana-kilitleri', az: 'smith-ql-vana-kilitleri' },
  'valve-lockout-carseal-wirelock': { tr: 'valve-lockout-carseal-wirelock', en: 'valve-lockout-carseal-wirelock', az: 'valve-lockout-carseal-wirelock' },
  'closure-lock': { tr: 'closure-lock', en: 'closure-lock', az: 'closure-lock' },
  'actuator-locking-mov-interlocks': { tr: 'actuator-locking-mov-interlocks', en: 'actuator-locking-mov-interlocks', az: 'actuator-locking-mov-interlocks' },
  // AZ slugs -> TR
  'acar-idareetmesi': { tr: 'anahtar-yonetimi', en: 'anahtar-yonetimi', az: 'acar-idareetmesi' },
  'ardicillik-nezareti': { tr: 'sira-kontrolu', en: 'sira-kontrolu', az: 'ardicillik-nezareti' },
};

// ============================================
// SOLUTIONS - 7 items (TR/EN/AZ matched)
// Note: EN uses TR slugs based on data
// ============================================
export const solutionSlugs = {
  // TR slugs
  'insan-hatasi-azaltma': { tr: 'insan-hatasi-azaltma', en: 'insan-hatasi-azaltma', az: 'insan-xetasi-azaltma' },
  'guvenli-vana-operasyonu': { tr: 'guvenli-vana-operasyonu', en: 'guvenli-vana-operasyonu', az: 'tehlukesiz-vana-emeliyyati' },
  'guvenlik-butunlugu': { tr: 'guvenlik-butunlugu', en: 'guvenlik-butunlugu', az: 'tehlukesizlik-butovluyu' },
  'hizli-vana-operasyonu': { tr: 'hizli-vana-operasyonu', en: 'hizli-vana-operasyonu', az: 'suretli-vana-emeliyyati' },
  'operasyonel-verimlilik': { tr: 'operasyonel-verimlilik', en: 'operasyonel-verimlilik', az: 'emeliyyat-semereililiyi' },
  'uzaktan-vana-operasyonu': { tr: 'uzaktan-vana-operasyonu', en: 'uzaktan-vana-operasyonu', az: 'uzaqdan-vana-emeliyyati' },
  'vana-pozisyon-izleme': { tr: 'vana-pozisyon-izleme', en: 'vana-pozisyon-izleme', az: 'vana-pozisiya-izleme' },
  'silo-ve-kamyon-yukleme-hassasiyeti': { tr: 'silo-ve-kamyon-yukleme-hassasiyeti', en: 'silo-and-truck-loading-precision', az: 'silo-ve-kamyon-yukleme-deqiqliyi' },
  'silo-and-truck-loading-precision': { tr: 'silo-ve-kamyon-yukleme-hassasiyeti', en: 'silo-and-truck-loading-precision', az: 'silo-ve-kamyon-yukleme-deqiqliyi' },
  'silo-ve-kamyon-yukleme-deqiqliyi': { tr: 'silo-ve-kamyon-yukleme-hassasiyeti', en: 'silo-and-truck-loading-precision', az: 'silo-ve-kamyon-yukleme-deqiqliyi' },
  // AZ slugs -> TR
  'insan-xetasi-azaltma': { tr: 'insan-hatasi-azaltma', en: 'insan-hatasi-azaltma', az: 'insan-xetasi-azaltma' },
  'tehlukesiz-vana-emeliyyati': { tr: 'guvenli-vana-operasyonu', en: 'guvenli-vana-operasyonu', az: 'tehlukesiz-vana-emeliyyati' },
  'tehlukesizlik-butovluyu': { tr: 'guvenlik-butunlugu', en: 'guvenlik-butunlugu', az: 'tehlukesizlik-butovluyu' },
  'suretli-vana-emeliyyati': { tr: 'hizli-vana-operasyonu', en: 'hizli-vana-operasyonu', az: 'suretli-vana-emeliyyati' },
  'emeliyyat-semereililiyi': { tr: 'operasyonel-verimlilik', en: 'operasyonel-verimlilik', az: 'emeliyyat-semereililiyi' },
  'uzaqdan-vana-emeliyyati': { tr: 'uzaktan-vana-operasyonu', en: 'uzaktan-vana-operasyonu', az: 'uzaqdan-vana-emeliyyati' },
  'vana-pozisiya-izleme': { tr: 'vana-pozisyon-izleme', en: 'vana-pozisyon-izleme', az: 'vana-pozisiya-izleme' },
};

// ============================================
// SECTORS/INDUSTRIES - 10 items (TR/EN/AZ matched)
// Note: EN uses TR slugs based on data
// ============================================
export const sectorSlugs = {
  // TR slugs (shared with EN based on data)
  'denizcilik-fpso': { tr: 'denizcilik-fpso', en: 'denizcilik-fpso', az: 'denizcilik-fpso' },
  'enerji-proses': { tr: 'enerji-proses', en: 'enerji-proses', az: 'enerji-proses' },
  'epc-projeleri': { tr: 'epc-projeleri', en: 'epc-projeleri', az: 'epc-layiheleri' },
  'hidrojen': { tr: 'hidrojen', en: 'hidrojen', az: 'hidrogen' },
  'karbon-yakalama': { tr: 'karbon-yakalama', en: 'karbon-yakalama', az: 'karbon-tutma' },
  'biyoyakitlar': { tr: 'biyoyakitlar', en: 'biofuels', az: 'bioyanacaqlar' },
  'lng-operasyonlari': { tr: 'lng-operasyonlari', en: 'lng-operations', az: 'lng-emeliyyatlari' },
  'kimya': { tr: 'kimya', en: 'kimya', az: 'kimya' },
  'su-atiksu': { tr: 'su-atiksu', en: 'su-atiksu', az: 'su-tullanti-su' },
  'tank-depolama': { tr: 'tank-depolama', en: 'tank-depolama', az: 'tank-saxlama' },
  'biofuels': { tr: 'biyoyakitlar', en: 'biofuels', az: 'bioyanacaqlar' },
  'lng-operations': { tr: 'lng-operasyonlari', en: 'lng-operations', az: 'lng-emeliyyatlari' },
  // AZ slugs -> TR
  'epc-layiheleri': { tr: 'epc-projeleri', en: 'epc-projeleri', az: 'epc-layiheleri' },
  'hidrogen': { tr: 'hidrojen', en: 'hidrojen', az: 'hidrogen' },
  'karbon-tutma': { tr: 'karbon-yakalama', en: 'karbon-yakalama', az: 'karbon-tutma' },
  'bioyanacaqlar': { tr: 'biyoyakitlar', en: 'biofuels', az: 'bioyanacaqlar' },
  'lng-emeliyyatlari': { tr: 'lng-operasyonlari', en: 'lng-operations', az: 'lng-emeliyyatlari' },
  'su-tullanti-su': { tr: 'su-atiksu', en: 'su-atiksu', az: 'su-tullanti-su' },
  'tank-saxlama': { tr: 'tank-depolama', en: 'tank-depolama', az: 'tank-saxlama' },
};

// ============================================
// SERVICES - 8 items (TR/EN/AZ matched)
// ============================================
export const serviceSlugs = {
  // TR slugs
  'operasyon-bakim': { tr: 'operasyon-bakim', en: 'operasyon-bakim', az: 'emeliyyat-texniki-xidmet' },
  'proje-destegi': { tr: 'proje-destegi', en: 'proje-destegi', az: 'layihe-desteyi' },
  'yonetmelikler-standartlar': { tr: 'yonetmelikler-standartlar', en: 'yonetmelikler-standartlar', az: 'qaydalar-standartlar' },
  'denetim': { tr: 'denetim', en: 'denetim', az: 'denetim' },
  'egitim': { tr: 'egitim', en: 'egitim', az: 'egitim' },
  'saha-denetimleri-ve-inspections': { tr: 'saha-denetimleri-ve-inspections', en: 'field-surveys-and-inspections', az: 'sahe-denetimleri-ve-inspections' },
  'bakim-ve-servis-destegi': { tr: 'bakim-ve-servis-destegi', en: 'maintenance-and-service-support', az: 'baxim-ve-servis-desteyi' },
  'turnaround-destegi': { tr: 'turnaround-destegi', en: 'turnaround-support', az: 'turnaround-desteyi' },
  'field-surveys-and-inspections': { tr: 'saha-denetimleri-ve-inspections', en: 'field-surveys-and-inspections', az: 'sahe-denetimleri-ve-inspections' },
  'maintenance-and-service-support': { tr: 'bakim-ve-servis-destegi', en: 'maintenance-and-service-support', az: 'baxim-ve-servis-desteyi' },
  'turnaround-support': { tr: 'turnaround-destegi', en: 'turnaround-support', az: 'turnaround-desteyi' },
  // AZ slugs -> TR
  'emeliyyat-texniki-xidmet': { tr: 'operasyon-bakim', en: 'operasyon-bakim', az: 'emeliyyat-texniki-xidmet' },
  'layihe-desteyi': { tr: 'proje-destegi', en: 'proje-destegi', az: 'layihe-desteyi' },
  'qaydalar-standartlar': { tr: 'yonetmelikler-standartlar', en: 'yonetmelikler-standartlar', az: 'qaydalar-standartlar' },
  'sahe-denetimleri-ve-inspections': { tr: 'saha-denetimleri-ve-inspections', en: 'field-surveys-and-inspections', az: 'sahe-denetimleri-ve-inspections' },
  'baxim-ve-servis-desteyi': { tr: 'bakim-ve-servis-destegi', en: 'maintenance-and-service-support', az: 'baxim-ve-servis-desteyi' },
  'turnaround-desteyi': { tr: 'turnaround-destegi', en: 'turnaround-support', az: 'turnaround-desteyi' },
};

// ============================================
// NEWS - 3 items (TR/EN/AZ matched)
// ============================================
export const newsSlugs = {
  'tank-dip-tahliye-vanasi': { tr: 'tank-dip-tahliye-vanasi', en: 'tank-bottom-drain-valve-safety-transformation', az: 'tank-alt-drenaj-vanasi-tehlukesizlik-semerelilik' },
  'tank-bottom-drain-valve-safety-transformation': { tr: 'tank-dip-tahliye-vanasi', en: 'tank-bottom-drain-valve-safety-transformation', az: 'tank-alt-drenaj-vanasi-tehlukesizlik-semerelilik' },
  'tank-alt-drenaj-vanasi-tehlukesizlik-semerelilik': { tr: 'tank-dip-tahliye-vanasi', en: 'tank-bottom-drain-valve-safety-transformation', az: 'tank-alt-drenaj-vanasi-tehlukesizlik-semerelilik' },
  'kamyon-yuklemesi-hassasiyet': { tr: 'kamyon-yuklemesi-hassasiyet', en: 'silo-terminal-loading-wrong-lineup-prevention', az: 'silo-terminal-yukleme-yanlis-xettlerin-qarsisinin-alinmasi' },
  'silo-terminal-loading-wrong-lineup-prevention': { tr: 'kamyon-yuklemesi-hassasiyet', en: 'silo-terminal-loading-wrong-lineup-prevention', az: 'silo-terminal-yukleme-yanlis-xettlerin-qarsisinin-alinmasi' },
  'silo-terminal-yukleme-yanlis-xettlerin-qarsisinin-alinmasi': { tr: 'kamyon-yuklemesi-hassasiyet', en: 'silo-terminal-loading-wrong-lineup-prevention', az: 'silo-terminal-yukleme-yanlis-xettlerin-qarsisinin-alinmasi' },
  'zincirli-vana-riskleri': { tr: 'zincirli-vana-riskleri', en: 'chain-wheel-valve-operation-risks', az: 'zencirli-vana-emeliyyat-riskleri' },
  'chain-wheel-valve-operation-risks': { tr: 'zincirli-vana-riskleri', en: 'chain-wheel-valve-operation-risks', az: 'zencirli-vana-emeliyyat-riskleri' },
  'zencirli-vana-emeliyyat-riskleri': { tr: 'zincirli-vana-riskleri', en: 'chain-wheel-valve-operation-risks', az: 'zencirli-vana-emeliyyat-riskleri' },
};

// ============================================
// BASE PATH MAPPING
// ============================================
export const basePathMapping = {
  tr: {
    applications: '/uygulamalar',
    products: '/urunler',
    solutions: '/cozumler',
    sectors: '/sektorler',
    services: '/hizmetler',
    news: '/haberler',
    customerStories: '/musteri-hikayeleri',
  },
  en: {
    applications: '/applications',
    products: '/products',
    solutions: '/solutions',
    sectors: '/industries',
    services: '/services',
    news: '/news',
    customerStories: '/customer-stories',
  },
  az: {
    applications: '/tetbiqler',
    products: '/mehsullar',
    solutions: '/heller',
    sectors: '/senayeler',
    services: '/xidmetler',
    news: '/xeberler',
    customerStories: '/musteri-hekayeleri',
  }
};

// Get page type from URL
export const getPageTypeFromUrl = (pathname) => {
  const pathLower = pathname.toLowerCase();
  
  if (pathLower.includes('/uygulamalar') || pathLower.includes('/applications') || pathLower.includes('/tetbiqler')) {
    return 'applications';
  }
  if (pathLower.includes('/urunler') || pathLower.includes('/products') || pathLower.includes('/mehsullar')) {
    return 'products';
  }
  if (pathLower.includes('/cozumler') || pathLower.includes('/solutions') || pathLower.includes('/heller')) {
    return 'solutions';
  }
  if (pathLower.includes('/sektorler') || pathLower.includes('/industries') || pathLower.includes('/senayeler')) {
    return 'sectors';
  }
  if (pathLower.includes('/hizmetler') || pathLower.includes('/services') || pathLower.includes('/xidmetler')) {
    return 'services';
  }
  if (pathLower.includes('/haberler') || pathLower.includes('/news') || pathLower.includes('/xeberler')) {
    return 'news';
  }
  if (pathLower.includes('/musteri-hikayeleri') || pathLower.includes('/customer-stories') || pathLower.includes('/musteri-hekayeleri')) {
    return 'customerStories';
  }
  return null;
};

// Get slug mapping based on page type
const getSlugMapping = (pageType) => {
  switch (pageType) {
    case 'applications': return applicationSlugs;
    case 'products': return productSlugs;
    case 'solutions': return solutionSlugs;
    case 'sectors': return sectorSlugs;
    case 'services': return serviceSlugs;
    case 'news': return newsSlugs;
    default: return {};
  }
};

const normalizePath = (inputPath) => {
  if (!inputPath) return '/';
  const cleanPath = inputPath.split('?')[0].split('#')[0] || '/';
  if (cleanPath.length > 1 && cleanPath.endsWith('/')) return cleanPath.slice(0, -1);
  return cleanPath;
};

const getUrlSuffix = (url) => {
  const queryIndex = url.indexOf('?');
  const hashIndex = url.indexOf('#');
  const firstIndex = [queryIndex, hashIndex].filter((idx) => idx >= 0).sort((a, b) => a - b)[0];
  return firstIndex >= 0 ? url.slice(firstIndex) : '';
};

const getRouteKeyFromPath = (pathname) => {
  const normalizedPath = normalizePath(pathname);
  for (const localeRoutes of Object.values(ROUTE_MAP)) {
    for (const [key, route] of Object.entries(localeRoutes)) {
      if (route === normalizedPath) return key;
    }
  }
  return null;
};

// Translate URL to target language
export const translateUrl = (currentUrl, targetLocale) => {
  if (!targetLocale || !ROUTE_MAP[targetLocale]) return currentUrl;

  const normalizedPath = normalizePath(currentUrl);
  const suffix = getUrlSuffix(currentUrl);

  // Home route is shared and should remain "/".
  if (normalizedPath === '/') {
    return `${ROUTE_MAP[targetLocale].home}${suffix}`;
  }

  // Handle all top-level pages (about/contact/news/docs/privacy/cookies/etc.).
  const routeKey = getRouteKeyFromPath(normalizedPath);
  if (routeKey && ROUTE_MAP[targetLocale][routeKey]) {
    return `${ROUTE_MAP[targetLocale][routeKey]}${suffix}`;
  }

  const pageType = getPageTypeFromUrl(normalizedPath);
  if (!pageType) return currentUrl;

  const slugMapping = getSlugMapping(pageType);
  const basePath = basePathMapping[targetLocale]?.[pageType];
  if (!basePath) return currentUrl;

  const parts = normalizedPath.split('/').filter(Boolean);
  if (parts.length <= 1) {
    return `${basePath}${suffix}`;
  }

  const slug = parts[parts.length - 1];
  const translatedSlug = slugMapping[slug]?.[targetLocale] || slug;

  return `${basePath}/${translatedSlug}${suffix}`;
};
